import { render, staticRenderFns } from "./MainNavigation.vue?vue&type=template&id=7819ad36"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"
import style0 from "./MainNavigation.vue?vue&type=style&index=0&id=7819ad36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports